export default __webpack_public_path__ + "static/media/door.dac4ccbf.svg";